import React, { FC, useEffect, useState } from "react";

import axios from "axios";
import DOMPurify from "dompurify";
import TableFilter from "./TableFilter";
import Table from "./Table";
import { TableComponentDiv, TableFootnote } from "./styles";
import { ButtonDefaultLink } from "../Form/Button/styles";

import * as XLSX from 'xlsx'

const { REACT_APP_API_URL } = process.env;

const hasVisibleRichText = (html: string) => {
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&#160;/gi, " ")
    .trim();

  return text.length > 0;
};

const TableComponent: FC<any> = () => {
  const [products, setProducts] = useState<any>([]);
  const [years, setYears] = useState<any>([]);
  const [months, setMonths] = useState<any>([]);
  const [messageBottomProduct, setMessageBottomProduct] = useState<any>();
  const [messageBottomUnity, setMessageBottomUnity] = useState<any>();
  const [discountMessage, setDiscountMessage] = useState<string | null>(null);
  const [searchResults, setSearchResults] = useState<any>([]);
  const [notaRodape, setNotaRodape] = useState<string | null>(null);

  const isFilled = (value: any) => {
    if (value === 0 || value === "0") {
      return true;
    }

    return value != null && String(value).trim() !== "";
  };

  const hasDiscountPrices =
    Array.isArray(searchResults) &&
    searchResults.some((item) => isFilled(item.preco_desconto));

  const effectiveDiscountMessage =
    discountMessage && hasDiscountPrices ? discountMessage : null;

  useEffect(() => {
    const filterProductsRequest = axios({
      method: "GET",
      url: `${REACT_APP_API_URL}/tarifas/produtos/`,
    });
    const filterYearsRequest = axios({
      method: "GET",
      url: `${REACT_APP_API_URL}/tarifas/anos/`,
    });
    const filterMonthsRequest = axios({
      method: "GET",
      url: `${REACT_APP_API_URL}/tarifas/meses/`,
    });

    axios
      .all([filterProductsRequest, filterYearsRequest, filterMonthsRequest])
      .then(
        axios.spread((...responses) => {
          const filterProducts = responses[0];
          const filterYears = responses[1];
          const filterMonths = responses[2];

          if (filterProducts.data) {
            setProducts(filterProducts.data);
          }

          if (filterYears.data) {
            setYears(filterYears.data);
          }

          if (filterMonths.data) {
            setMonths(filterMonths.data);
          }
        })
      );
  }, []);


  const filter = () => {
    let productId;
    let yearId;
    let monthId;
    
    const productsFilterInput = document.querySelector('.products .react-dropdown-select-content span')
    const yearsFilterInput = document.querySelector('.years .react-dropdown-select-content span')
    const monthsFilterInput = document.querySelector('.months .react-dropdown-select-content span')
    
    if (productsFilterInput) {
        Array.isArray(products) && products.forEach((item) => {
            if(item.nome === productsFilterInput.innerHTML) {
                productId = item.id;
                setMessageBottomProduct(item.nome);
                setMessageBottomUnity(item.unidade);
                setDiscountMessage(
                  isFilled(item.desconto_mensagem)
                    ? String(item.desconto_mensagem).trim()
                    : null
                );
            }
        })
    }

    if (yearsFilterInput) {
        Array.isArray(years) && years.forEach((item) => {
            if(item.nome == yearsFilterInput.innerHTML) {
                yearId = item.ano;
            }
        })
    }

    if (monthsFilterInput) {
        Array.isArray(months) && months.forEach((item) => {
            if(item.nome === monthsFilterInput.innerHTML) {
                monthId = item.mes;
            }
        })
    }

    if (productId && yearId && monthId) {
      setNotaRodape(null);

      const filterSearchRequest = axios({
        method: "GET",
        url: `${REACT_APP_API_URL}/tarifas/?produto=${productId}&ano=${yearId}&mes=${monthId}`,
      });
  
      axios
        .all([filterSearchRequest])
        .then(
          axios.spread((...responses) => {
            const filterSearchResults = responses[0];
            const payload = filterSearchResults.data;
  
            if (payload) {
              setSearchResults(Array.isArray(payload.precos) ? payload.precos : []);
              setNotaRodape(
                typeof payload.nota_rodape === "string" ? payload.nota_rodape : null
              );
            }
          })
        );
    }
  }

  const downloadFunction = () => {
    const tableData = searchResults.map((tableColumn: any) => {
      const { id, preco_desconto, ...rest } = tableColumn;

      if (effectiveDiscountMessage) {
        return {
          ...rest,
          [effectiveDiscountMessage]: isFilled(preco_desconto) ? preco_desconto : "",
        };
      }

      return rest;
    })

    const workbook = XLSX.utils.book_new();
    const worksheet:any = XLSX.utils.json_to_sheet(tableData);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1');
    XLSX.writeFile(workbook, 'table_sheet.xlsx');
  }

  const sanitizedNota = notaRodape ? DOMPurify.sanitize(notaRodape) : "";
  const showNota = hasVisibleRichText(sanitizedNota);

  return (
    <>
      <TableComponentDiv>
        <strong className="tableTitle">Preços às distribuidoras</strong>

        <TableFilter 
          products={products} 
          years={years} 
          months={months} 
          functionClick={filter} 
          messageBottomProduct={messageBottomProduct}
          messageBottomUnity={messageBottomUnity} 
        />

        <Table searchResults={searchResults} discountMessage={effectiveDiscountMessage} />

        {showNota && (
          <TableFootnote dangerouslySetInnerHTML={{ __html: sanitizedNota }} />
        )}

        <ButtonDefaultLink 
          className="download-button" 
          rel="noopener noreferrer"
          onClick={downloadFunction}
        >
          Baixar Arquivo XLS
        </ButtonDefaultLink>
      </TableComponentDiv>
    </>
  );
};

export default TableComponent;
